import React__default, { useState, useEffect } from 'react';
import { Img } from '../Img/Img.es.js';

const avatar = "_avatar_13ug1_1";
const img = "_img_13ug1_55";
const styles = {
	avatar: avatar,
	img: img
};

const getNameInitials = (name) => {
  const initials = (name || "").trim().split(/\s+/).map((s) => s[0]);
  const firstLetter = initials[0];
  const lastLetter = initials[initials.length - 1];
  if (!firstLetter) {
    return "";
  }
  return initials.length === 1 ? String(firstLetter) : `${firstLetter}${lastLetter}`;
};
const SIZES = {
  small: 24,
  medium: 36,
  large: 48
};
const Avatar = ({ "aria-hidden": ariaHidden, color, isBlock, isInteractive, isSelected, name, url, shouldLazilyLoad = true, size = "small" }) => {
  const [hasError, setHasError] = useState(false);
  const initials = name ? getNameInitials(name) : null;
  useEffect(() => {
    if (hasError) {
      setHasError(false);
    }
  }, [url]);
  const showInitials = !url || url && hasError;
  return React__default.createElement("div", { "aria-hidden": ariaHidden, "aria-label": name, className: styles.avatar, "data-block": isBlock ? "true" : void 0, "data-color": color, "data-show-initials": showInitials, "data-interactive": isInteractive ? "true" : void 0, "data-selected": isSelected ? "true" : void 0, "data-size": size, "data-testid": "Avatar", "data-zds": true, role: "img" }, url && !hasError ? React__default.createElement(Img, { className: styles.img, alt: name, "aria-hidden": true, height: SIZES[size], onError: () => setHasError(true), src: url, width: SIZES[size], loading: shouldLazilyLoad ? "lazy" : "eager" }) : React__default.createElement("span", null, initials));
};

export { Avatar };
//# sourceMappingURL=Avatar.es.js.map
